/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import theme, { Content_Text } from "../Component/theme";
import image_main_solution from "../image/image_main_solution.png";
import img_client3 from "../image/img_client3.png";
import img_main_top from "../image/img_main_top2.png";

import Cookie from "js-cookie";
import moment from "moment";
import Event_Modal from "../Component/Event_Modal";
import Footer_FMS from "../2.FMS/Footer_FMS";
import Header_Main from "./Header_Main";
import image_main_back from "../image/image_main_back.png";
import image_main_back2 from "../image/image_main_back2.png";
import image_main_dadem from "../image/image_main_dadem.png";
import image_main_na from "../image/image_main_na.png";
import image_main_petch from "../image/image_main_petch.png";
import image_service from "../image/image_service.png";
import image_service2 from "../image/image_service2.png";
import fms_price from "../image/img_main_fms_price.png";
import fms_price2 from "../image/img_main_fms_price2.png";
import fms_price3 from "../image/img_main_fms_price3.png";
import price from "../image/img_main_price.png";
import price2 from "../image/img_main_price2.png";
import price3 from "../image/img_main_price3.png";
import Side_Main from "./Side_Main";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;

const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;

const Main_Back = styled.img`
  position: absolute;
  width: 100%;
  height: 800px;
  margin-top: 400px;
  @media (max-width: 800px) {
    height: 500px;
    margin-top: 200px;
  }
`;
const Main_Back2 = styled.img`
  position: absolute;
  width: 100%;
  height: 1400px;
  @media (max-width: 800px) {
    height: 700px;
    width: auto;
  }
`;

const Main = styled.main`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;

const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
  position: relative;
`;

const Main_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const Main_div3 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  padding-top: 100px;
  background-color: white;
  @media (max-width: 800px) {
    padding-top: 0px;
  }
`;

const Main_div4 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
  position: relative;
  padding-bottom: 400px;

  @media (max-width: 800px) {
    overflow: hidden;
    padding-bottom: 200px;
  }
`;

const Main_div6 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: white;
  padding-bottom: 50px;
  @media (max-width: 800px) {
    padding-bottom: 0px;
  }
`;

const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 100px;
  z-index: 5;

  @media (max-width: 800px) {
    /* flex-direction: column; 모바일 화면에서는 열 방향 */
    padding-top: 50px;
    padding-bottom: 0px;
  }
`;

const Main_init_div2 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 100px;
  flex-direction: column;
  z-index: 5;

  @media (max-width: 800px) {
    /* flex-direction: column; 모바일 화면에서는 열 방향 */
    padding-top: 50px;
    padding-bottom: 0px;
  }
`;

const Main_init_div3 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 100px;
  z-index: 5;
  justify-content: space-between;

  @media (max-width: 800px) {
    /* flex-direction: column; 모바일 화면에서는 열 방향 */
    padding-top: 0px;
    padding-bottom: 0px;
    overflow: scroll;
  }
`;

const Main_init_div4 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  z-index: 5;

  @media (max-width: 800px) {
  }
`;

const Main_init_div5 = styled.div`
  display: flex;
  width: 100%;
  z-index: 5;
  padding: 5px;
  align-items: center;
  background-color: #fafafa;
  border-radius: 16px;
`;

const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) =>
    props.$left ? "flex-start" : props.$right ? "flex-end" : "center"};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) =>
    props.$left ? "flex-start" : props.$right ? "flex-end" : "center"};
  max-width: 1280px;
  @media (max-width: 1500px) {
    padding: 0px 60px 20px 60px;
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    padding: 0px 15px 20px 15px;
    /* text-align: center; */
  }
`;

const Main_Content2 = styled.div`
  flex: 1;
  display: grid;
  justify-content: flex-end;
  align-items: flex-end;
  align-self: center;
  text-align: end;
  max-width: 1280px;
  height: 100px;
  margin-bottom: 100px;
  @media (max-width: 1500px) {
    padding: 0px 60px 20px 60px;
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    padding: 0px 15px 20px 15px;
    /* text-align: center; */
  }
`;

const Main_Content3 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  > .text {
    margin-top: 10px;
  }
`;

const Main_Content4 = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) =>
    props.$left ? "flex-start" : props.$right ? "flex-end" : "center"};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) =>
    props.$left ? "flex-start" : props.$right ? "flex-end" : "center"};
  max-width: 1280px;
`;

const Main_Button = styled.button`
  /* background-color: ${(props) =>
    props.$black ? "black" : theme.colors.main2}; */
  background-image: ${"linear-gradient(to right, #5C97FE,#536AFF )"};
  padding: 16px 40px;
  border-radius: 8px;
  border-style: solid;
  border-width: 0px;
  margin-right: 15px;
  @media (max-width: 800px) {
    margin-bottom: 15px;
    padding: 10px 16px;
  }
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: white;
    ${Content_Text} {
      transition: color 0.3s ease;
      color: black;
    }
  }
`;
const Select_Button = styled.button`
  background-color: ${(props) => (props.$select ? "white" : "#FAFAFA")};
  padding: 6px 0px;
  width: 120px;
  border-radius: 8px;
  border-style: solid;
  border-width: ${(props) => (props.$select ? 1 : 0)}px;
  border-color: ${theme.colors.fontBlue};
  @media (max-width: 800px) {
    padding: 4px 0px;
    width: 60px;
  }
  cursor: pointer;
`;
const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Main_Top_IMG = styled(Image)`
  width: 520px;
  position: absolute;
  right: 100px;
  bottom: 0px;
  top: 50px;
  @media (max-width: 1500px) {
    width: 410px;
    right: 15px;
  }
  @media (max-width: 800px) {
    width: 90px;
    right: 0px;
    top: 70px;
  }
`;

const Main_Solution = styled(Image)`
  width: 520px;
  height: 520px;
  @media (max-width: 1500px) {
    width: 410px;
    height: 410px;
    right: 15px;
  }
  @media (max-width: 800px) {
    width: 120px;
    height: 120px;
    right: 0px;
  }
`;

const Price_IMG = styled(Image)`
  width: 100%;
  display: flex;
  cursor: pointer;
  @media (max-width: 1500px) {
    display: none;
  }
`;
const Price_IMG2 = styled(Image)`
  width: 100%;
  display: none;
  cursor: pointer;
  @media (max-width: 1500px) {
    display: flex;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
const Price_IMG3 = styled(Image)`
  width: 100%;
  display: none;
  cursor: pointer;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Service_Report_Div = styled.div`
  display: flex;
  width: 70%;
  align-self: center;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  @media (max-width: 800px) {
    margin-top: 15px;
    width: 90%;
  }
  &.top {
    margin-top: 20px;
    @media (max-width: 800px) {
      margin-top: 0px;
    }
  }

  > .text-l {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 100px;
    @media (max-width: 800px) {
      margin-right: 15px;
    }
  }
  > .text-r {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 100px;
    @media (max-width: 800px) {
      margin-left: 15px;
    }
  }
`;

const Service_Report_Image = styled.img`
  display: flex;
  flex: 1;
  @media (max-width: 800px) {
    width: 180px;
    height: 180px;
  }
`;

const PP_Image = styled.img`
  align-self: center;
  width: 400px;
  height: 400px;

  @media (max-width: 1500px) {
    height: 300px;
    width: 300px;
  }
  @media (max-width: 800px) {
    height: 200px;
    width: 200px;
  }
`;

const PP_More_Btn = styled.div`
  background-image: ${"linear-gradient(to right, #5C97FE,#536AFF )"};
  padding: 16px 45px;
  border-radius: 8px;
  border-width: 0px;
  @media (max-width: 800px) {
    margin-bottom: 15px;
    padding: 10px 16px;
  }
  cursor: pointer;
`;

function Home() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const [event, set_Event] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const open_event = () => set_Event(true);
  const close_event = () => set_Event(false);
  const [select, set_Select] = useState("앱");
  const go_About = (item) => {
    navigation("/about", { state: { data: item } });
    window.scrollTo({ top: 0 });
  };
  const go_Platform_Info = (item) => {
    navigation("/Platform_Info", { state: { data: item } });
    window.scrollTo({ top: 0 });
  };
  const go_Event_About = () => {
    navigation("/Event_About");
    window.scrollTo({ top: 0 });
  };
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    const event_show = Cookie.get("event_show");
    // console.log(event_show);
    if (event_show !== "no" && new Date() < moment("2024-04-27 00:00:00")) {
      open_event();
    }
    // Cookie.remove("event_show");

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Main page="Home" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Side_Main />
        <Main_div>
          <Main_init_div>
            <Main_Content $left>
              <>
                <Content_Text $black="true" $extra="true" $xxbold="true">
                  링크캠퍼스에서
                </Content_Text>
                <Content_Text $blue="true" $extra="true" $xxbold="true">
                  최적의{" "}
                  <Content_Text $blue="true" $extra="true" $xxbold="true">
                    웹/앱 서비스 개발
                  </Content_Text>
                  <Content_Text $black="true" $extra="true" $xxbold="true">
                    을
                  </Content_Text>
                </Content_Text>
                <Content_Text $black="true" $extra="true" $xxbold="true">
                  시작해보세요.
                </Content_Text>
                <br></br>
                <Content_Text $darkGray="true">
                  모바일 어플리케이션부터 웹, FMS 시설관리시스템까지
                </Content_Text>
                <Content_Text $darkGray="true">
                  다양한 서비스를 제작해드립니다.
                </Content_Text>
                <br></br>
                <br></br>
                <div>
                  <Main_Button
                    $num={"1"}
                    onClick={() => {
                      go_About();
                    }}
                  >
                    <Content_Text $xlarge $bold="true" $white="true">
                      제작문의
                    </Content_Text>
                  </Main_Button>
                </div>
              </>
            </Main_Content>
            <Main_Top_IMG src={img_main_top} alt={img_main_top} />
          </Main_init_div>
          <Main_Back src={image_main_back} alt={image_main_back} />
        </Main_div>
        <Main_div2>
          <Main_init_div>
            <Main_Solution
              src={image_main_solution}
              alt={image_main_solution}
            />
            <Main_Content2 $right>
              <>
                <Content_Text $white="true" $extra="true" $xxbold="true">
                  링크캠퍼스는 고객님과의
                </Content_Text>
                <Content_Text $white="true" $extra="true" $xxbold="true">
                  연결을 통해 더 나은
                </Content_Text>
                <Content_Text $white="true" $extra="true" $xxbold="true">
                  솔루션을 제공합니다.
                </Content_Text>
                <br></br>
                <Content_Text $white="true">
                  고객님과의 관계를 중요시하며, 단기적인 이익이 아닌
                </Content_Text>
                <Content_Text $white="true">
                  장기적인 관계 추구합니다.
                </Content_Text>
              </>
            </Main_Content2>
          </Main_init_div>
        </Main_div2>

        <Main_div2>
          <Main_init_div>
            <Main_Content>
              <Content_Text>링크캠퍼스를 통해 FMS를 운영하고 있는</Content_Text>
              <Content_Text $xxlarge $xxbold>
                42개의 클라이언트사가 있습니다.
              </Content_Text>
              <Image
                style={{ width: "100%", marginTop: 20 }}
                src={img_client3}
                alt={img_client3}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div2>

        <Main_div4>
          <Main_init_div2>
            <Main_Content $left>
              <Content_Text $white="true" $extra="true" $xxbold="true">
                서비스 소개
              </Content_Text>
              <Content_Text
                $darkGray="true"
                style={{ marginTop: 10, color: "#C0C0C0" }}
              >
                웹/앱 개발 및 FMS(시설관리시스템)를 제작 가능합니다.
              </Content_Text>
            </Main_Content>
            <Service_Report_Div className="top">
              <div className="text-l">
                <Content_Text $darkGray="true" $small="true" $bold="true">
                  01
                </Content_Text>
                <Content_Text
                  $white="true"
                  $xmlarge="true"
                  $bold="true"
                  style={{ marginTop: 10 }}
                >
                  웹/앱 제작
                </Content_Text>
                <Content_Text
                  $darkGray="true"
                  style={{ marginTop: 5, color: "#C0C0C0" }}
                >
                  &nbsp;고객님의 요구에 맞춘 맞춤형 웹/앱 제작 서비스를
                  제공합니다. 최신 기술과 철저한 보안 시스템을 바탕으로, 사용자
                  친화적이고 안전한 플랫폼을 구축해 신뢰할 수 있는 경험을 보장해
                  드립니다.
                </Content_Text>
              </div>
              <Service_Report_Image src={image_service} alt={image_service} />
            </Service_Report_Div>
            <Service_Report_Div>
              <Service_Report_Image src={image_service2} alt={image_service2} />

              <div className="text-r">
                <Content_Text $darkGray="true" $small="true" $bold="true">
                  02
                </Content_Text>
                <Content_Text
                  $white="true"
                  $xmlarge="true"
                  $bold="true"
                  style={{ marginTop: 10 }}
                >
                  FMS 제작
                </Content_Text>
                <Content_Text
                  $darkGray="true"
                  style={{ marginTop: 5, color: "#C0C0C0" }}
                >
                  &nbsp;효율적인 시설관리시스템(FMS)을 통해 시설 관리의 투명성과
                  운영 효율을 극대화합니다. 실시간 데이터 기반의 맞춤형
                  솔루션으로, 시설 관리를 최적화하여 비즈니스 성장을 지원하며,
                  전담 매니저가 편리하게 관리할 수 있는 시스템을 제공합니다.
                </Content_Text>
              </div>
            </Service_Report_Div>
          </Main_init_div2>
          <Main_Back2 src={image_main_back2} alt={image_main_back2} />
        </Main_div4>

        <Main_div>
          <Main_init_div4>
            <Main_Content $right="true">
              <Content_Text
                $black
                $extra="true"
                $xxbold="true"
                style={{ textAlign: "end" }}
              >
                포트폴리오
              </Content_Text>
              <Content_Text $darkGray="true" style={{ marginTop: 10 }}>
                링크캠퍼스에서 제작한 웹/앱 입니다.
              </Content_Text>
            </Main_Content>
          </Main_init_div4>
        </Main_div>
        <Main_div>
          <Main_init_div3>
            <Main_Content3
              style={{ marginRight: 40 }}
              onClick={() => go_Platform_Info("Dadem")}
            >
              <PP_Image src={image_main_dadem} alt={image_main_dadem} />
              <Content_Text $darkGray="true" className="text">
                다되는 예약제 대학배달앱
              </Content_Text>
              <Content_Text $xmlarge="true" $xbold="true">
                다댐
              </Content_Text>
            </Main_Content3>
            <Main_Content3
              style={{ marginRight: 40 }}
              onClick={() => go_Platform_Info("Petch")}
            >
              <PP_Image src={image_main_petch} alt={image_main_petch} />
              <Content_Text $darkGray className="text">
                동물병원 진료비 검색할 땐?
              </Content_Text>
              <Content_Text $xmlarge="true" $xbold="true">
                펫치
              </Content_Text>
            </Main_Content3>
            <Main_Content3 onClick={() => go_Platform_Info("NA")}>
              <PP_Image src={image_main_na} alt={image_main_na} />
              <Content_Text $darkGray className="text">
                단역, 보조출연을 하고싶다면?
              </Content_Text>
              <Content_Text $xmlarge="true" $xbold="true">
                뉴액터스
              </Content_Text>
            </Main_Content3>
          </Main_init_div3>
        </Main_div>
        <Main_div>
          <PP_More_Btn>
            <Content_Text $xlarge="true" $bold="true" $white="true">
              더 보기
            </Content_Text>
          </PP_More_Btn>
        </Main_div>

        <Main_div3>
          <Main_init_div>
            <Main_Content $left="true">
              <Content_Text
                $xxbold="true"
                $extra="true"
                style={{ marginBottom: 4 }}
              >
                서비스 예상 가격
              </Content_Text>
              <Content_Text $darkGray="true">
                예상 가격이며 변동사항이 있을수도 있습니다.
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div3>

        <Main_div3 style={{ paddingTop: 0 }}>
          <Main_init_div style={{ paddingTop: 60 }}>
            <Main_Content>
              <Main_init_div5>
                <Main_Content4>
                  <Select_Button
                    $select={select === "앱"}
                    onClick={() => {
                      set_Select("앱");
                    }}
                  >
                    <Content_Text $blue={select === "앱"} $lightGray>
                      웹/앱
                    </Content_Text>
                  </Select_Button>
                </Main_Content4>
                <Main_Content4>
                  <Select_Button
                    $select={select === "FMS"}
                    onClick={() => {
                      set_Select("FMS");
                    }}
                  >
                    <Content_Text $blue={select === "FMS"} $lightGray>
                      FMS
                    </Content_Text>
                  </Select_Button>
                </Main_Content4>
              </Main_init_div5>
            </Main_Content>
          </Main_init_div>
        </Main_div3>
        <Main_div6>
          {select === "앱" ? (
            <Main_init_div style={{ paddingTop: 30 }}>
              <Main_Content style={{ justifyItems: "center" }}>
                <Price_IMG
                  src={price}
                  alt={price}
                  onClick={() => go_About("앱/웹")}
                />
                <Price_IMG2
                  src={price2}
                  alt={price2}
                  onClick={() => go_About("앱/웹")}
                />
                <Price_IMG3
                  src={price3}
                  alt={price3}
                  onClick={() => go_About("앱/웹")}
                />
              </Main_Content>
            </Main_init_div>
          ) : (
            <Main_init_div style={{ paddingTop: 30 }}>
              <Main_Content style={{ justifyItems: "center" }}>
                <Price_IMG
                  src={fms_price}
                  alt={fms_price}
                  onClick={() => go_About("FMS")}
                />
                <Price_IMG2
                  src={fms_price2}
                  alt={fms_price2}
                  onClick={() => go_About("FMS")}
                />
                <Price_IMG3
                  src={fms_price3}
                  alt={fms_price3}
                  onClick={() => go_About("FMS")}
                />
              </Main_Content>
            </Main_init_div>
          )}
        </Main_div6>
        <Main_div style={{ paddingBottom: 150 }}>
          <PP_More_Btn
            onClick={() => go_About(select === "앱" ? "앱/웹" : "FMS")}
          >
            <Content_Text $xlarge="true" $bold="true" $white="true">
              제작문의
            </Content_Text>
          </PP_More_Btn>
        </Main_div>
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Event_Modal
        show={event}
        onClose={close_event}
        go_Event_About={go_Event_About}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Home;
